<div class="all-in-one-table content-layout">

  <div [ngClass]="sendEmailList?.length>5?'example-container':'none'" style="overflow-x:auto;">
    <!-- Grid Header -->
    <div class="grid-container">
      <div class="grid-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0px">
        <div class="grid-column" fxFlex="10">Client Name</div>
        <div class="grid-column" fxFlex="20">Email</div>
        <div class="grid-column" fxFlex="10">Subject</div>
        <div class="grid-column" fxFlex="45">Body</div>
        <!-- <div class="grid-column" fxFlex="10">Opened</div> -->
        <div class="grid-column" fxFlex="10">Opened Time</div>
        <div class="grid-column" fxFlex="10">Clicked</div>
        <div class="grid-column" fxFlex="10">Status</div>
        <div class="grid-column" fxFlex="10">Error</div>
        <div class="grid-column" fxFlex="15">Link</div>
      </div>

      <!-- Grid Body -->
      <div class="grid-body">
        <div class="grid-row" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0px"
          *ngFor="let row of sendEmailList; let ri = index">
          <div class="grid-cell" fxFlex="10">{{ row.clientName || row.client?.name || '-' }}</div>
          <div class="grid-cell" fxFlex="20">{{ row.email || row.toEmail || '-' }}</div>
          <div class="grid-cell" fxFlex="10">{{ row.subject || '-' }}</div>
          <div class="grid-cell body-cell" fxFlex="45">
            <div class="email-section">
              <div class="email-header" (click)="toggleEmailDetails(row)">
                <span class="material-icons-outlined">email</span>
                <span class="title">Body</span>
                <span class="material-icons-outlined arrow-icon" [class.open]="row.showEmailDetails">
                  keyboard_arrow_down
                </span>
              </div>

              <div class="email-details" [@expandCollapse]="row.showEmailDetails ? 'open' : 'closed'">
                <div [innerHTML]="row.body ? (row.body) : '-'" class="email-body-html"></div>
              </div>
            </div>
          </div>
          <!-- <div class="grid-cell" fxFlex="10">{{ row.opened === true ? 'Yes' : (row.opened === false ? 'No' : (row.opened
            ||
            '-')) }}</div> -->
          <div class="grid-cell" fxFlex="10">{{ row.openedTime ? (row.openedTime | date:'yyyy-MM-dd HH:mm:ss') : '-' }}
          </div>
          <div class="grid-cell" fxFlex="10">{{ row.clicked != null ? row.clicked : '-' }}</div>
          <div class="grid-cell" fxFlex="10"><span class="status-badge">{{ row.status || '-' }}</span></div>
          <div class="grid-cell" fxFlex="10">{{ row.errorMessage || row.error || '-' }}</div>

          <div class="grid-cell body-cell" fxFlex="15">
            <div class="email-section">
              <div class="email-header" (click)="toggleEmailTrackingId(row)">
                <span class="material-icons-outlined">link</span>

                <!-- <span class="title">Email Links</span> -->

                <span class="material-icons-outlined arrow-icon" [class.open]="row.showEmailLinksDetails">
                  keyboard_arrow_down
                </span>
              </div>

              <div class="email-details" [@expandCollapse]="row.showEmailLinksDetails ? 'open' : 'closed'">

                <ng-container *ngIf="links?.length; else noLinks">
                  <ul class="email-links">
                    <li *ngFor="let link of links">
                      <a [href]="link.linkUrl" target="_blank" rel="noopener noreferrer">
                        {{ link.linkUrl }}
                      </a>
                    </li>
                  </ul>
                </ng-container>

                <ng-template #noLinks>
                  <span class="empty">-</span>
                </ng-template>
              </div>

            </div>
          </div>

        </div>

        <div class="no-records-message" fxLayoutAlign="center center" *ngIf="!sendEmailList?.length">
          No records found
        </div>
      </div>
    </div>
    <!-- /.grid-container -->
  </div>

  <!-- Paginator -->
  <div *ngIf="sendEmailList?.length>0" class="paginator-wrap" fxLayout="row" fxLayoutAlign="end center"
    fxLayoutGap="5px">
    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
      [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
  </div>

</div>